import { useEffect, useRef } from 'react'

export function initPixel() {}
export function setupGlobalTracking() {}
export function track(event: string, data?: any) {}
export function trackCustom(name: string, data?: any) {}

export function useSectionView(name: string, threshold = 0.3) {
  const ref = useRef<HTMLElement | null>(null)
  useEffect(() => {
    if (!ref.current) return
    const el = ref.current
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          track('ViewContent', { content_name: name })
          observer.disconnect()
        }
      },
      { threshold },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [name, threshold])
  return ref
}
